import { createSlice } from "@reduxjs/toolkit";
import {
  getPackages,
  getPackageById,
  addPackage,
  updatePackage,
  deletePackage,
} from "./thunk";

export const initialState = {
  packages: [],
  totalPages: 1,
  currentPage: 1,
  selectedPackage: null,
  error: {},
};

const PackagesSlice = createSlice({
  name: "PackagesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // GET ALL
    builder.addCase(getPackages.fulfilled, (state, action) => {
      state.packages = action.payload?.data || action.payload;
      state.totalPages =
        action.payload.responseDetails?.pagination?.totalPages || 1;
      state.currentPage =
        action.payload.responseDetails?.pagination?.currentPage || 1;
    });

    builder.addCase(getPackages.rejected, (state, action) => {
      state.error = action.payload?.error || action.error.message;
    });

    // GET BY ID
    builder.addCase(getPackageById.fulfilled, (state, action) => {
      state.selectedPackage = action.payload;
    });

    builder.addCase(getPackageById.rejected, (state, action) => {
      state.error = action.payload?.error || action.error.message;
    });

    // ADD
    builder.addCase(addPackage.fulfilled, (state, action) => {
      const newPackage = action.payload?.data || action.payload;
      state.packages.unshift(newPackage);
    });

    builder.addCase(addPackage.rejected, (state, action) => {
      state.error = action.payload?.error || action.error.message;
    });

    // UPDATE
    builder.addCase(updatePackage.fulfilled, (state, action) => {
      const updatedData = action.payload?.data || action.payload;
      const updatedId = action.payload.id;

      state.packages = state.packages.map((pkg) =>
        pkg._id === updatedId ? { ...pkg, ...updatedData } : pkg,
      );
    });

    builder.addCase(updatePackage.rejected, (state, action) => {
      state.error = action.payload?.error || action.error.message;
    });

    // DELETE
    builder.addCase(deletePackage.fulfilled, (state, action) => {
      state.packages = state.packages.filter(
        (pkg) => pkg._id !== action.payload.id,
      );
    });

    builder.addCase(deletePackage.rejected, (state, action) => {
      state.error = action.payload?.error || action.error.message;
    });
  },
});

export default PackagesSlice.reducer;
